var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loader position-relative"},[_c('div',{staticClass:"icon-wrapper"},[_c('i',{staticClass:"fas icon-loader animation-shimmer",class:"me-bmt icon-motionelements"})])])}
var staticRenderFns = []

export { render, staticRenderFns }